import VisitInformationIcon from '@/common/assets/icons/visitInformationIcon.svg?react';
import CustomIcon from '@/common/components/base/customIcon/CustomIcon';
import CustomLabel from '@/common/components/base/customLabel/CustomLabel';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import CardButton from '@/common/components/cardButton/CardButton';
import MainLayout from '@/common/components/layouts/MainLayout';
import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import AdjusterImageIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/adjusterImageIcon.svg?react';
import AskedImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/askedImagesIcon.svg?react';
import ComplimentImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/complimentImagesIcon.svg?react';
import SignatureImageIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/signatureImageIcon.svg?react';
import { getImagesTabsQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritImagesTabs/getImagesTabsQueryOptions';
import { getDamagedAdjusterImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedAdjusterImages/getDamagedAdjusterImagesQueryOptions';
import getDamagedImageTabsAlertsQueryOptions from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedImageTabsAlerts/getDamagedImageTabsAlertsQueryOptions';
import { AdjusterTabImageCard } from '@/modules/adjusterReportModules/IncidentParticipants/types/entryTab.type';
import { HandleRoutesNavigation } from '@/modules/adjusterReportModules/IncidentParticipants/utils/HandleRoutesNavigation';
import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';
import DocumentImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/documentImagesIcon.svg?react';

const DamagedImagesTabPage = () => {
  return (
    <MainLayout title=" تصاویر / زیان‌دیده" header="titleHeader">
      <DamagedImagesTab />
    </MainLayout>
  );
};

const DamagedImagesTab = () => {
  const { id, damagedId } = useParams();
  const navigate = useNavigate();
  const { data: entryTabsData } = useQuery(
    getImagesTabsQueryOptions({
      id: +id!,
      userType: 'damaged',
      damaged_id: +damagedId!,
    }),
  );

  const { isPending } = useQuery(
    getDamagedImageTabsAlertsQueryOptions({
      damage_id: +damagedId!,
      id: +id!,
    }),
  );
  const { data: vehicleImages } = useQuery(
    getDamagedAdjusterImagesQueryOptions({
      id: +id!,
      enable: true,
      damaged_id: +damagedId!,
      participantRoleType: 'damaged',
    }),
  );

  const renderRoute = (item: AdjusterTabImageCard<'damaged'>) => {
    const editable = item.editable;
    const damagedImagesLinks = ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_IMAGES({
      id: +id!,
      damagedId: damagedId!,
    });

    let tabIcon: Record<AdjusterTabImageCard<'damaged'>['name'], string> = {
      damaged_image: HandleRoutesNavigation({
        edit: damagedImagesLinks.ADJUSTER_OTHER_DAMAGED.edit,
        show: damagedImagesLinks.ADJUSTER_OTHER_DAMAGED.show,
        isEditable: editable,
      }),
      adjuster_vehicle_image: HandleRoutesNavigation({
        edit: damagedImagesLinks.ADJUSTER_VEHICLE.damagedPoints,
        show: damagedImagesLinks.ADJUSTER_VEHICLE.showPreviewImages,
        editableAfterPost:
          damagedImagesLinks.ADJUSTER_VEHICLE.editablePreviewImages,
        isEditableAfterPost: !!vehicleImages?.vehicle.length,
        isEditable: editable,
      }),
      adjuster_document_image: HandleRoutesNavigation({
        edit: damagedImagesLinks.ADJUSTER_DOCUMENT.edit,
        show: damagedImagesLinks.ADJUSTER_DOCUMENT.show,
        isEditable: editable,
      }),
      adjuster_additional_image: HandleRoutesNavigation({
        edit: damagedImagesLinks.ADJUSTER_ADDITIONAL.edit,
        show: damagedImagesLinks.ADJUSTER_ADDITIONAL.show,
        isEditable: editable,
      }),

      signature: HandleRoutesNavigation({
        edit: damagedImagesLinks.SIGNATURE.edit,
        show: damagedImagesLinks.SIGNATURE.show,
        isEditable: editable,
      }),
      customer_vehicle_image: damagedImagesLinks.customerVehicle,
      customer_document_image: damagedImagesLinks.customerDocument,
      customer_additional_image: damagedImagesLinks.customerAdditional,

      corrective_image: damagedImagesLinks.corrective,
    };
    return tabIcon[item.name];
  };
  const goToFile = (item: AdjusterTabImageCard<'damaged'>) => {
    // if (error && item.editable && item.name === 'adjuster_image') {
    //   vehicleTypeErrorModalOpenModal();
    //   return;
    // }
    navigate(renderRoute(item));
  };

  return (
    <Box pt="2rem">
      {isPending ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          <CircularLoading color="colors.purple-primary" />
        </Box>
      ) : (
        <Box
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            position: 'relative',
            top: '-5px',
          })}
        >
          <Box
            className={css({
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            })}
          >
            <TitleDescription>تصاویر کارشناس</TitleDescription>
            <Box>
              {entryTabsData?.adjuster?.map(
                (item: AdjusterTabImageCard<'damaged'>, index) => {
                  return item.exists ? (
                    <CardButton
                      key={item?.name}
                      cardProps={{
                        className: css({
                          marginY: '1rem',
                          marginTop: index === 0 ? '0rem' : '1rem',
                        }),
                        onClick: () => goToFile(item),
                      }}
                      hasArrow
                      renderTag={() =>
                        item?.label && (
                          <CustomLabel
                            title={item?.label?.fa_const}
                            color={
                              item?.label?.const === 'uncompleted'
                                ? 'black'
                                : 'green'
                            }
                          />
                        )
                      }
                      renderIcon={() => renderIcon(item.name)}
                      title={item?.fa_name}
                    />
                  ) : null;
                },
              )}
            </Box>
            <Box>
              {entryTabsData?.customer.exist ? (
                <TitleDescription>تصاویر مشتری</TitleDescription>
              ) : null}

              {entryTabsData?.customer?.exist &&
                entryTabsData?.customer?.list?.map(
                  (item: AdjusterTabImageCard<'damaged'>, index) => {
                    if (!item.exists) return null;
                    return (
                      <>
                        <CardButton
                          key={item?.name}
                          cardProps={{
                            className: css({
                              marginY: '1rem',
                              marginTop: index === 0 ? '0rem' : '1rem',
                            }),
                            onClick: () => goToFile(item),
                          }}
                          hasArrow
                          renderTag={() =>
                            item?.label && (
                              <CustomLabel
                                title={item?.label?.fa_const}
                                color={
                                  item?.label?.const === 'uncompleted'
                                    ? 'black'
                                    : 'green'
                                }
                              />
                            )
                          }
                          renderIcon={() => renderIcon(item.name)}
                          title={item?.fa_name}
                        />
                      </>
                    );
                  },
                )}
            </Box>
          </Box>

          {entryTabsData?.signature?.length ? (
            <>
              {entryTabsData.signature.map(
                (item: AdjusterTabImageCard<'damaged'>) => (
                  <Box>
                    <TitleDescription>امضا زیاندیده</TitleDescription>
                    <CardButton
                      title={item?.fa_name!}
                      cardProps={{
                        className: css({ marginY: '1rem' }),
                        onClick: () => goToFile(item),
                      }}
                      renderIcon={() => renderIcon(item.name)}
                      hasArrow
                      renderTag={() =>
                        item?.label && (
                          <CustomLabel
                            title={item?.label?.fa_const}
                            color={
                              item?.label?.const === 'uncompleted'
                                ? 'black'
                                : 'green'
                            }
                          />
                        )
                      }
                    />
                  </Box>
                ),
              )}
            </>
          ) : null}
          {entryTabsData?.corrective_image?.length
            ? entryTabsData?.corrective_image?.map(
                (item: AdjusterTabImageCard<'damaged'>) => (
                  <>
                    <Box>
                      <TitleDescription>تصاویر درخواستی</TitleDescription>
                      <CardButton
                        title={item?.fa_name!}
                        cardProps={{
                          className: css({ marginY: '1rem' }),
                          onClick: () => {
                            goToFile(item);
                          },
                        }}
                        renderIcon={() => renderIcon(item.name)}
                        hasArrow
                        renderTag={() => (
                          <CustomLabel title={item?.count!} color={'orange'} />
                        )}
                      />
                    </Box>
                  </>
                ),
              )
            : null}
        </Box>
      )}
    </Box>
  );
};
export default DamagedImagesTabPage;

const renderIcon = (tabName: AdjusterTabImageCard<'damaged'>['name']) => {
  let tabIcon: Record<
    AdjusterTabImageCard<'damaged'>['name'],
    React.JSX.Element
  > = {
    damaged_image: <AskedImagesIcon />,
    adjuster_vehicle_image: (
      <CustomIcon backgroundColor="orange-3" width={40} height={40}>
        <VisitInformationIcon stroke={token('colors.orange')} />
      </CustomIcon>
    ),
    adjuster_additional_image: <ComplimentImagesIcon />,
    adjuster_document_image: <DocumentImagesIcon />,

    customer_vehicle_image: (
      <CustomIcon backgroundColor="green-4" width={40} height={40}>
        <VisitInformationIcon />
      </CustomIcon>
    ),
    customer_additional_image: <ComplimentImagesIcon />,
    customer_document_image: <AdjusterImageIcon />,

    corrective_image: <AskedImagesIcon />,
    signature: <SignatureImageIcon />,
  };
  return tabIcon[tabName];
};
